import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { AuthService } from "src/app/services/auth.service";
import { ConfirmationModalComponent } from "../../common/confirmation-modal/confirmation-modal.component";

@Component({
  selector: "app-register",
  templateUrl: "./register.component.html",
  styleUrls: ["./register.component.scss"],
})
export class RegisterComponent {
  registerForm: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public ref: MatDialogRef<RegisterComponent>,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private auth: AuthService
  ) {
    this.registerForm = this.fb.group({
      name: [data.first_name, Validators.required],
      last_name: [data.last_name, Validators.required],
      email: [data.email, [Validators.required, Validators.email]],
    });
  }

  onSubmit() {
    if (this.registerForm.valid) {
      const formData = this.registerForm.value;
      // console.log(formData); // This will log the form data
      const body = {
        first_name: formData.name,
        last_name: formData.last_name,
        email: formData.email,
      };
      if (formData.re_pass == formData.pass) {
        this.auth.registerMethod(body, this.data.token).subscribe(
          (res: any) => {
            if (res.error === false) {
              // console.log(res);
              this.closeDialog("done");
            } else {
              // console.log("Registration failed: ", res.message);
              this.openDialog(res.message);
            }
          },
          (error) => {
            console.error("Error:", error);
          }
        );
      }
    }
  }

  closeDialog(msg: string) {
    this.ref.close(msg);
  }

  openDialog(err: String) {
    if (err == "Validation Error") {
      err = "Please Enter the Strong Password";
    }
    if (
      err ==
      'User not able to get created due to duplicate key value violates unique constraint "auth_user_username_key"\nDETAIL:  Key (username)=(hitesh) already exists.\n'
    ) {
      err = "User already exists";
    }
    this.dialog.open(ConfirmationModalComponent, {
      enterAnimationDuration: "350ms",
      data: {
        error: err,
      },
    });
  }
  validateEmail(email: string): boolean {
    const emailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email regex pattern
    return emailRegex.test(email);
  }
}
